import React, { useState } from "react";
import Button from "@components/Button";
import CustomInput, {
  CustomSelectInput,
} from "@components/CustomInput/CustomInput";
import styles from "./SignUpComponent.module.css";
import { Link } from "react-router-dom";
import useAuth from "@hooks/useAuth";

const genderOptions = [
  {
    option: "Male",
    value: "Male",
  },
  {
    option: "Female",
    value: "Female",
  },
  {
    option: "Others",
    value: "Others",
  },
];

const SignUpComponent = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    gender: "",
    contact: "",
    email: "",
    password: "",
    repeatPassword: "",
  });

  const { handleSignUp } = useAuth();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = () => {
    handleSignUp(formData);
  };

  return (
    <div className={styles.Wrapper}>
      <div className={styles.NameWrapper}>
        <CustomInput
          showLabel
          label={"First Name"}
          name="firstName"
          onChange={handleInputChange}
        />
        <CustomInput
          showLabel
          label={"Last Name"}
          name="lastName"
          onChange={handleInputChange}
        />
      </div>
      <div className={styles.NameWrapper}>
        <CustomInput
          showLabel
          label={"Contact"}
          name="contact"
          onChange={handleInputChange}
        />
        <CustomSelectInput
          className={styles.Gender}
          selectOptions={genderOptions}
          defaultOption={"Gender"}
          name="gender"
          onChange={handleInputChange}
        />
      </div>
      <CustomInput
        showLabel
        label={"Email"}
        name="email"
        onChange={handleInputChange}
      />
      <CustomInput
        showLabel
        label={"Password"}
        name="password"
        onChange={handleInputChange}
      />
      <CustomInput
        showLabel
        label={"Confirm Password"}
        name="repeatPassword"
        onChange={handleInputChange}
      />
      <Link to="/forgotpassword">Forgot password</Link>
      <Link to="/signin">Signin instead</Link>
      <Button btnType={"primary"} text={"Signup"} onClick={handleSubmit} />
    </div>
  );
};

export default SignUpComponent;

// firstName: Joi.string().alphanum().min(1).max(30).required(),
// lastName: Joi.string().alphanum().min(1).max(30),
// gender: Joi.string().alphanum().min(4).max(6),
// contact: Joi.string().regex(/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/),
// email: Joi.string().email().lowercase().required(),
// password: Joi.string().min(6).max(50).required(),
// repeatPassword: Joi.ref("password")
